export default __webpack_public_path__ + "static/media/family.562c8c69.svg";